import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, CheckCircle2, ListChecks, PackageCheck } from 'lucide-react';

const STATUS_ITEMS = [
  'Shipment created',
  'Product details saved',
  'Agentic checklist generation will run in the next step',
];

export default function PreparingChecklist() {
  const { shipmentId } = useParams();

  return (
    <div className="space-y-6" data-testid="preparing-checklist-page">
      <div>
        <Link
          to="/shipments"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white"
          data-testid="preparing-checklist-back"
        >
          <ArrowLeft className="h-4 w-4" />
          All shipments
        </Link>
      </div>

      <div className="rounded-2xl border border-white/10 bg-navy-900 p-6 md:p-8">
        <div className="flex flex-col gap-5 md:flex-row md:items-start md:justify-between">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-widest text-cyan-glow font-mono">Shipment workflow</div>
            <h2 className="mt-2 font-display text-3xl font-bold tracking-tight">Preparing your shipment checklist</h2>
            <p className="mt-2 text-sm text-slate-400">
              Your shipment record is ready. The next workflow step will generate the checklist, but that action has not started yet.
            </p>
          </div>
          <div className="rounded-xl border border-cyan-glow/20 bg-cyan-glow/10 px-4 py-3 text-sm text-cyan-glow font-mono">
            Shipment ID: {shipmentId}
          </div>
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-[1.2fr_0.8fr]">
          <div className="rounded-xl border border-white/10 bg-navy-950/50 p-5">
            <div className="flex items-start gap-4">
              <div className="grid h-11 w-11 place-items-center rounded-xl border border-cyan-glow/20 bg-cyan-glow/10 text-cyan-glow">
                <ListChecks className="h-5 w-5" />
              </div>
              <div>
                <div className="font-display text-xl font-semibold text-white">Shipment registration complete</div>
                <p className="mt-1 text-sm text-slate-400">
                  The shipment and its products are saved. You can now continue into the checklist generation step when that workflow is enabled.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-white/10 bg-navy-950/50 p-5">
            <div className="flex items-center gap-3">
              <div className="grid h-10 w-10 place-items-center rounded-lg border border-emerald-500/20 bg-emerald-500/10 text-emerald-400">
                <PackageCheck className="h-5 w-5" />
              </div>
              <div className="text-sm text-slate-300">Current status</div>
            </div>
            <div className="mt-4 space-y-3">
              {STATUS_ITEMS.map((item) => (
                <div key={item} className="flex items-start gap-3 text-sm text-slate-300">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
